export function humanizeKey(value = '') {
  return String(value)
    .replace(/^nav\.items\./, '')
    .replace(/^nav\.sections\./, '')
    .replace(/^pages\./, '')
    .replace(/^header\./, '')
    .replace(/^quick_actions\./, '')
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase())
    .trim();
}

export function safeT(t, key, fallback = '') {
  const translated = t(key);
  if (translated && translated !== key) return translated;

  if (import.meta?.env?.DEV) {
    console.warn(`[i18n] Missing translation: ${key}`);
  }

  return fallback || humanizeKey(key);
}

function looksLikeI18nKey(value = '') {
  return /^(nav\.items|nav\.sections|pages|header|quick_actions)\./.test(String(value));
}

export function resolveNavItemLabel(item, t, overrideLabel) {
  if (overrideLabel) return overrideLabel;
  if (item?.labelKey) return safeT(t, item.labelKey, item?.label || humanizeKey(item?.id));
  if (item?.label && looksLikeI18nKey(item.label)) {
    return safeT(t, item.label, humanizeKey(item?.id || item.label));
  }
  if (item?.label) return item.label;
  return safeT(t, `nav.items.${item?.id}`, humanizeKey(item?.id));
}

export function resolveNavSectionLabel(sectionKey, group, t, overrideLabel) {
  if (overrideLabel) return overrideLabel;
  if (group?.titleKey) return safeT(t, group.titleKey, group?.title || humanizeKey(sectionKey));
  if (group?.title && looksLikeI18nKey(group.title)) {
    return safeT(t, group.title, humanizeKey(sectionKey || group.title));
  }
  if (group?.title) return group.title;
  return safeT(t, `nav.sections.${sectionKey}`, humanizeKey(sectionKey));
}

// Sous-titre de regroupement (bandeau au sein d'une section, ex. 'Curriculum
// & Pédagogie') — `item.group` est un slug ASCII (ex. 'curriculum_pedagogie'),
// jamais le libellé affichable directement : un libellé français accentué en
// dur dans portalNavigation.js aurait été compté comme texte hors i18n par le
// gate bilinguisme, qui scanne aussi les .js (pas seulement les .jsx) —
// mesuré le 2026-10-11 par une autre session en rebasant par-dessus (PR #39).
export function resolveNavGroupLabel(groupSlug, t, overrideLabel) {
  if (overrideLabel) return overrideLabel;
  if (!groupSlug) return groupSlug;
  return safeT(t, `nav.groups.${groupSlug}`, humanizeKey(groupSlug));
}

export function canonicalKey(key) {
  if (!key || typeof key !== 'string') return key;
  return key.replace(/-(piloter|produire|soutenir|controler|ameliorer)$/, '');
}
